<div class="modal-content">
  <div class="modal-header bg-primary-100">
    <h5 class="modal-title"><i class="bi bi-bug-fill text-primary"></i> Unexpected Error</h5>
  </div>
  <div class="modal-body">
    <p>An unexpected error has occurred in the application. Please try again.</p>
  </div>
  <div class="modal-footer d-flex">
    @if (currentRouteType === RouteType.Cert) {
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Close</button>
    } @else {
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Close</button>
    }
  </div>
</div>
